import config, { vars } from '@app/config'

import { isBuyerTokenMode } from './isBuyerTokenMode'

export const getActiveB2CCookieNames = () => {
  if (isBuyerTokenMode()) {
    return {
      accessTokenCookie: vars.buyer_access_token,
      refreshTokenCookie: config.variables.b2c_refresh_token,
    }
  }

  return {
    accessTokenCookie: config.variables.b2c_access_token,
    refreshTokenCookie: config.variables.b2c_refresh_token,
  }
}
